import { render, staticRenderFns } from "./User.vue?vue&type=template&id=370062d4&scoped=true&lang=html&"
import script from "./User.vue?vue&type=script&lang=ts&"
export * from "./User.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370062d4",
  null
  
)

export default component.exports